import React, { Component } from 'react';
// import BlockButton from 'components/UI/BlockButton';
// import Typography from '@material-ui/core/Typography';
// import Box from '@material-ui/core/Box';
import { formatDate } from 'helpers/stringUtils';
import { withRouter } from 'react-router-dom';
// import i18n from 'helpers/i18n'
import getCardImage from 'helpers/getCardImage'; // import List from '@material-ui/core/List';
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
// import ListItemAvatar from "@material-ui/core/ListItemAvatar";
// import Avatar from "@material-ui/core/Avatar";
import Grid from '@material-ui/core/Grid';
import getRemainingTime from 'helpers/getRemainingTime';
import clsx from 'clsx';
import i18n from 'helpers/i18n';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import RemainingTime from 'components/UI/RemainingTime';
import Button from '@material-ui/core/Button';
import EventTimeGrid from 'components/Event/EventTimeGrid';
import { withStyles } from '@material-ui/core/styles';
const styles = (theme) => ({
  root: {
    // marginBottom: '80px',
    // '& .MuiTypography-h4': {
    //   // color: theme.palette.text.dark
    // }
  },
  // eventTitle: {
  //   marginBottom: theme.spacing(2),
  //   [theme.breakpoints.down("sm")]: {
  //     order: 2,
  //   },
  // },
  // eventSpeaker: {
  //   marginBottom: theme.spacing(2),
  //   [theme.breakpoints.down("sm")]: {
  //     padding: theme.spacing(2),
  //     order: 1,
  //   },
  // },
  // title: {
  //   borderBottom: "none",
  //   margin: 0,
  //   padding: 0,
  // },
  // avatar: {
  //   width: "100%",
  //   height: "100%",
  //   maxWidth: 150,
  //   maxHeight: 150
  // },
  inline: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  // inlineIcon: {
  //   display: "inline-block",
  //   verticalAlign: "middle",
  //   marginTop: "-3px",
  //   marginRight: theme.spacing(1),
  // },
  // h6extends: {
  //   color: theme.palette.text.dark,
  //   [theme.breakpoints.down("sm")]: {
  //     fontSize: "1rem",
  //   },
  // },
  // underline: {
  //   position: "relative",
  //   paddingBottom: 30,
  //   "&:after": {
  //     content: '" "',
  //     position: "absolute",
  //     bottom: 0,
  //     width: 100,
  //     left: "calc(50% - (100px/2))",
  //     height: 2,
  //     borderBottom: "2px " + theme.palette.secondary.main + " solid",
  //   },
  // },
  // boxWrapper: {
  //   width: '100%',
  //   backgroundColor: theme.palette.primary.light,
  //   padding: 40,
  //   marginBottom: 20,
  //   [theme.breakpoints.down("sm")]: {
  //     padding: 20,
  //   },
  // },
  // eventSubscriptionWrapper: {
  //   textAlign: "right",
  //   [theme.breakpoints.down("sm")]: {
  //     textAlign: "center",
  //   },
  // },
  fullWidth: {
    width: '100%',
  },
});
class EventSubscriptionRecap extends Component {
  render() {
    const {
      // remainingTimeDays,
      // remainingTimeHours,
      // remainingTimeMinutes,
      showLiveButton,
      $$subscriptions,
      $$selectedEvents,
      onDateChange,
      onGotoLiveRoom,
      classes,
    } = this.props;
    if ($$selectedEvents.size < 1) return;
    const timeRemaining =
      $$selectedEvents !== undefined && $$selectedEvents.size >= 0
        ? getRemainingTime($$selectedEvents.get(0).get('eventDate'))
        : {};
    // console.log('FOO', timeRemaining)
    const wording =
      $$selectedEvents.size > 1
        ? {
            session: 'aux sessions suivantes',
            nextConf: 'Votre prochaine conférence débute dans:',
          }
        : {
            session: 'à la session suivante',
            nextConf: 'La conférence débute dans:',
          };
    // console.log({      remainingTimeDays,
    //       remainingTimeHours,
    //       remainingTimeMinutes,
    // })
    return (
      <Grid container item spacing={0} xs={12} justify="center" alignItems="center" className={classes.root}>
        <If condition={showLiveButton !== true}>
          <Grid item xs={12}>
            <Box align="center" mt={3} mb={3}>
              <Typography variant="h4" color="textPrimary">
                {`Vous êtes inscrit(e) ${wording.session}:`}
              </Typography>
            </Box>
          </Grid>
          <Grid container item spacing={2} xs={12} justify="center" className={classes.root} align="center">
            {$$selectedEvents.map(($$card, cIdx) => {
              return (
                <EventTimeGrid
                  key={'k_' + cIdx}
                  $$card={$$card}
                  selected={false}
                  subscribed={$$subscriptions !== undefined && $$subscriptions.contains($$card.get('id'))}
                />
              );
            })}
          </Grid>
        </If>
        <Grid item xs={12}>
          <Box mt={3} align="center">
            <If condition={showLiveButton !== true}>
              <span className={classes.inline}>
                <Typography variant="h6" color="textPrimary">
                  {`${wording.nextConf}`}
                </Typography>
              </span>
              <span className={classes.inline}>
                <RemainingTime
                  days={timeRemaining.days}
                  hours={timeRemaining.hours}
                  minutes={timeRemaining.minutes}
                  variant={'h6'}
                  style={{ textAlignt: 'left', margin: '0 0 0 5px' }}
                />
              </span>
            </If>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <If condition={showLiveButton !== true}>
            <Box mt={3} align="center" className={classes.alignCenter}>
              <Button variant="contained" color="secondary" size="large" onClick={onDateChange}>
                {$$selectedEvents.size === 1 ? i18n.get('cardDateModify') : i18n.get('cardDatesModify')}
              </Button>
            </Box>
            <Box mt={3} align="center" className={classes.alignCenter}>
              <Button
                variant="contained"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/');
                }}
              >
                {i18n.get('backToHome')}
              </Button>
            </Box>
          </If>
          <If condition={showLiveButton === true}>
            <Typography variant="h4" color="primary" align="center" gutterBottom={true}>
              {i18n.get('cardAlreadyStarted')}
            </Typography>
            <Box mt={3} align="center" className={classes.fullWidth}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={onGotoLiveRoom}
                className={classes.buttonLarge}
              >
                {i18n.get('cardLiveBtn')}
              </Button>
            </Box>
          </If>
        </Grid>
      </Grid>
    );
  }
}
// export default ;
export default withRouter(withStyles(styles)(EventSubscriptionRecap));



// WEBPACK FOOTER //
// ./src/components/EventSubscription/EventSubscriptionRecap.jsx